import { Button, Stack, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { MotionViewport, varFade } from 'src/components/animate';
import ImageViewer from 'src/features/components/lightbox';
import { StyledContainer } from '../Ads/styles';
import { StyledPictureContainer } from './styles';

// ------------------------------------------------------------------

export default function Highlights() {
  return (
    <Stack component={MotionViewport}>
      <StyledContainer>
        <Typography variant="h4" align="center" mb={6} mt={6}>
          Fotos em Destaque
        </Typography>

        <StyledPictureContainer variants={varFade().in}>
          <ImageViewer length={12} folder="destaques" label="Fotos em Destaque" exe="webp" />

          <NavLink to="destaques">
            <Button variant="contained"> Ver mais </Button>
          </NavLink>
        </StyledPictureContainer>
      </StyledContainer>
    </Stack>
  );
}
